<template>
  <table class="table">
    <thead>
      <tr>
        <th>Đường dẫn</th>
        <th>Thời gian chỉnh sửa</th>
        <th>Thời gian quét</th>
        <th>Kích cỡ</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="file in explorer_store.files" :key="file.id">
        <template v-if="file.name && file.path">
          <td class="max-w-sm break-all">
            <div class="flex items-baseline gap-1">
              <IcoFile v-if="file.type.toLowerCase() === 'file'" />
              <IcoFolder v-if="file.type.toLowerCase() === 'folder'" />
              <RouterLink
                v-if="file.type.toLowerCase() === 'folder'"
                :to="{
                  name: 'ClientExplorer',
                  query: {
                    ...$route.query,
                    path: file.path,
                  },
                }"
                class="link"
              >
                {{ file.name }}
              </RouterLink>
              <span v-else>
                {{ file.name }}
              </span>
            </div>
          </td>
          <td>
            <template v-if="file.modified">
              {{ dayjs.unix(file.modified).format("YYYY/MM/DD HH:mm:ss") }}
            </template>
            <template v-else>
              <span class="text-base-content/20 italic">
                Không có thông tin
              </span>
            </template>
          </td>
          <td>
            <template v-if="file.created">
              {{
                dayjs.unix(file.created / 1000).format("YYYY/MM/DD HH:mm:ss")
              }}
            </template>
            <template v-else>
              <span class="text-base-content/20 italic">
                Không có thông tin
              </span>
            </template>
          </td>
          <td>
            <template v-if="file.size">
              {{ prettyBytes(file.size ?? 0) }}
            </template>
            <template v-else>
              <span class="text-base-content/20 italic">
                Không có thông tin
              </span>
            </template>
          </td>
          <template
            v-if="
              true
              // dayjs.unix(file.created / 1000).isAfter(dayjs().subtract(1, 'hour'))
            "
          >
            <td>
              <ActionMenu
                @delete="explorer_store.handle_delete(file.path)"
                @download="file_download.create_download_file_action(file.path)"
                @rename="
                  show_rename_modal({
                    full_path: file.path,
                    parent_dir: file.parent_dir,
                    file_name: file.name,
                  })
                "
                @execute="show_create_execute_model(file.path)"
                :file_or_folder="file.type.toLowerCase()"
              />
            </td>
          </template>
        </template>
      </tr>
    </tbody>
  </table>
  <ExecuteArgsModal :file_path="execute_model_props?.file_path" />
  <RenameModal
    :parent_dir="rename_model_props?.parent_dir"
    :file_name="rename_model_props?.file_name"
  />
  <DownloadModal />
</template>
<script setup lang="ts">
import IcoFile from "@/components/IcoFile.vue";
import IcoFolder from "@/components/IcoFolder.vue";
import dayjs from "dayjs";
import prettyBytes from "pretty-bytes";
import { ref } from "vue";
import ActionMenu from "./ActionMenu.vue";
import DownloadModal from "./DownloadModal.vue";
import ExecuteArgsModal from "./ExecuteArgsModal.vue";
import RenameModal from "./RenameModal.vue";
import { use_explorer } from "./useExplorer";
import { use_file_download } from "./useFileDownload";

const explorer_store = use_explorer();
const file_download = use_file_download();
const rename_model_props = ref<{
  full_path: string;
  parent_dir: string;
  file_name: string;
}>();
const execute_model_props = ref<{
  file_path: string;
}>({
  file_path: "",
});
const show_rename_modal = (props: {
  full_path: string;
  parent_dir: string;
  file_name: string;
}) => {
  if (!document.getElementById("rename_modal")) return;
  rename_model_props.value = props;
  (document.getElementById("rename_modal") as HTMLDialogElement).showModal();
};
const show_create_execute_model = (f: string) => {
  execute_model_props.value.file_path = f;
  (
    document.getElementById("create_execute_action") as HTMLDialogElement
  ).showModal();
};
</script>
